// extracted by mini-css-extract-plugin
export default {"inputWrapper":"_c7e60030","halfInputWrapper":"_474bcb33 _c7e60030","disclaimerSpacing":"_48556ad7"};